let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aYP9q")).then(() => parcelRequire('5hZy0'));